import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const PlannerSenior = () => {
    useEffect(() => {
        document.title = 'Planner Senior -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>The Almanac</li>
                <li>School Planner</li>
                 <li>Planner Senior</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Planner Senior </h1>
                    </div>
                </div>
                <div className="row">
                 <div className="col-lg-12">
                 <iframe src='https://webapi.entab.info/api/image/TAFS/public/pdf/PlannerSenior.pdf' width="100%" height="600"></iframe>
                           
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default PlannerSenior